export default "__VITE_ASSET__hf7RS$o1__"